import metrikaGoal from '~h/metrikaGoal';
import analyticsWidgetsUsing from '~h/analyticsWidgetsUsing';

const authLocalKey = 'analyticsAuth';

export const analyticParams = {
  auth: 'Новый пользователь',
  for_who: 'Зарегистрировал себя',
  payment: 'Физ. лицо',
  use_widgets: analyticsWidgetsUsing(),
};

export const getLocalAuthParam = () => {
  return localStorage.getItem(authLocalKey);
};

export const setLocalAuthParam = value => {
  if (value == null) {
    localStorage.removeItem(authLocalKey);
  } else {
    localStorage.setItem(authLocalKey, value);
  }
};

const getDataGetter = (selector, way) => (fieldName) => {
  return !!fieldName ? $(selector)[way](fieldName) : $(selector)[way]();
};

export const registerAnalyticEvent = () => {
  metrikaGoal('reg-send', analyticParams);
  metrikaGoal('scenario-search-reg-send');
  metrikaGoal('scenario-menu-reg-send');
  metrikaGoal('scenario-slider-reg-send');
  metrikaGoal('scenario-playbill-reg-send');

  // Ecom analytics
  const getDataByFieldName = getDataGetter('#page-registration_course', 'data');

  const eventPrice = parseFloat(getDataByFieldName('event_price'));
  const productLineName = getDataByFieldName('product_line_name') || 'null';
  const disciplineName = getDataByFieldName('discipline_name') || 'null';
  const eventName = getDataGetter('.txt--lg', 'html')() || 'null';

  // eslint-disable-next-line no-undef
  dataLayer.push({
    event: 'Ecommerce',
    ecommerce: {
      purchase: {
        actionField: {
          id: `${getDataByFieldName('event_id')}-${new Date().getTime()}`,
        },
        products: [
          {
            id: getDataByFieldName('event_id'),
            name: eventName,
            price: eventPrice || '0',
            category: `${productLineName}/${disciplineName}/${eventName}`,
            quantity: 1,
          },
        ],
      },
    },
  });
};
